import axios from 'axios'



export default class SettingsService {


  

    async getLevels(token) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/levels',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async saveLevels(data, token) {

        console.log('usao na sejv')

        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/savelevels',
                headers: {
                    authorization: token
                },
                data: data
                
            })
            return res.data.id

        } catch (error) {

            console.log(error);
        }

        return 0;
    }



     
}


